<ion-content class="modal-outher-container">
  <ion-grid
    class="modal-inner-container modal-inner-container--scroll custom-scrollbar"
  >
    <ion-row>
      <ion-col>
        <app-modal-header
          header="{{ 'COMMENTS.CONTRACTOR' | translate }}"
          (close)="back()"
        >
        </app-modal-header>

        <div class="transfefr-task__inner-container">
          <app-select-user
            [label]="translateServ.instant('COMMENTS.CONTRACTOR_CHANGE')"
            [selectedUser]="reportTaskService.reportTask.performedBy"
          ></app-select-user>
          <ion-item class="input">
            <div class="control-display">
              <ion-label>{{ "COMMENTS.COMMENT" | translate }}</ion-label>
              <ion-textarea
                class="margin-top-0"
                rows="3"
                [(ngModel)]="comment"
              ></ion-textarea>
            </div>
          </ion-item>
          <ion-item class="input" lines="none">
            <ion-button
              class="button-margin-top-md"
              (click)="save()"
              size="medium"
              slot="end"
              >{{ "SAVE" | translate }}
            </ion-button>
          </ion-item>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
